(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("widgets/ck-editor", [], factory);
	else if(typeof exports === 'object')
		exports["widgets/ck-editor"] = factory();
	else
		root["widgets/ck-editor"] = factory();
})(self, () => {
return 